import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import toLower from 'lodash/toLower';
import startCase from 'lodash/startCase';
import {
    Typography,
    ListItem,
    ListItemText,
    List,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Divider,
    IconButton,
    Hidden,
} from '@material-ui/core';
import { findByLabelText } from '@testing-library/react';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: 309,
    },
    gridContainer: {
        padding: 10,
    },
    avatar: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        margin: 'auto',
        marginBottom: 20,
    },
    photoButton: {
        maxWidth: 200,
        marginBottom: 20,
    },

    button: {
        marginTop: 24,
        margin: theme.spacing(1),
    },
    fecharButton: {
        display: 'flex',
        alignItems: 'flex-end',
        textAlign: 'right',
        justifyContent: 'flex-end',
        paddingTop: 5,
        paddingRight: 5,
    },
    tableRoot: {
        borderBottom: 'none',
    },
    tableLabel: {
        borderBottom: 'none',
        width: '15px',
        fontWeight: 'bold',
    },
}));

export default function MembroDetalhes({
    membro,
    handleFechar,
    handleIncluirNoMeuGrupo,
}) {
    const classes = useStyles();

    return (
        <Paper className={classes.root}>
            {!!membro ? (
                <>
                    <Hidden smUp>
                        {handleFechar && (
                            <div className={classes.fecharButton}>
                                <IconButton onClick={handleFechar}>
                                    <CloseIcon></CloseIcon>
                                </IconButton>
                            </div>
                        )}
                    </Hidden>
                    <Grid
                        className={classes.gridContainer}
                        direction="row"
                        container
                        alignItems="center"
                        justify="center"
                    >
                        <Grid
                            item
                            xs={12}
                            sm={'auto'}
                            style={{ textAlign: 'center' }}
                        >
                            <Avatar
                                alt="Foto"
                                src={membro.txFotoUrl}
                                className={classes.avatar}
                            />
                            <Button
                                fullWidth
                                variant="outlined"
                                color="primary"
                                disabled={!!membro.idGrupoPequeno}
                                onClick={e => {
                                    handleIncluirNoMeuGrupo(e, membro);
                                }}
                                className={classes.photoButton}
                            >
                                Incluir no meu grupo
                            </Button>
                        </Grid>
                    </Grid>
                    {!!membro.idGrupoPequeno && (
                        <Table className={classes.table}>
                            <TableBody>
                                <TableRow className={classes.tableRoot}>
                                    <TableCell
                                        className={classes.tableLabel}
                                        style={{ width: 123 }}
                                    >
                                        G.A:
                                    </TableCell>
                                    <TableCell className={classes.tableRoot}>
                                        <span translate="no">
                                        {!!membro.txNomeLider2
                                            ? [
                                                  startCase(
                                                      toLower(
                                                          membro.txNomeLider1
                                                      )
                                                  ),
                                                  startCase(
                                                      toLower(
                                                          membro.txNomeLider2
                                                      )
                                                  ),
                                              ].join(' e ')
                                            : startCase(
                                                  toLower(membro.txNomeLider1)
                                              )}
                                        </span>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    )}
                    <Divider></Divider>
                    <Table className={classes.table} aria-label="simple table">
                        <TableBody>
                            <TableRow className={classes.tableRoot}>
                                <TableCell className={classes.tableLabel}>
                                    Nome:
                                </TableCell>
                                <TableCell className={classes.tableRoot}>
                                    <span translate="no">{startCase(toLower(membro.txAluno))}</span>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.tableLabel}>
                                    Nascimento:
                                </TableCell>
                                <TableCell className={classes.tableRoot}>
                                    {membro.dtNascimento}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.tableLabel}>
                                    Matrícula:
                                </TableCell>
                                <TableCell className={classes.tableRoot}>
                                    {membro.txMatricula}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.tableLabel}>
                                    Telefone:
                                </TableCell>
                                <TableCell className={classes.tableRoot}>
                                    {membro.txTelefoneCel}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </>
            ) : (
                <div
                    style={{
                        minHeight: 309,
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    Pesquise um membro para ver os detalhes
                </div>
            )}
        </Paper>
    );
}
